import axios from 'axios';
import * as types from './types';
import { API_URL_PATHS, CADESS_API_CONFIG } from '../../constants/url';
import {
  CASE_LEVEL,
  CASE_PART_ONE,
  caseStatus,
  NOTIFICATION_STATUS,
  userRoles,
} from '../../constants';
import { getTokenHeader } from '../../helpers/tokenHelper';
import { displayNotification } from './NotificationActions';
import { validateAnalysisValues } from '../../helpers/validateFormsDemo';

export const getCasesSuccess = res => ({ type: types.GET_CASES_SUCCESS, res });

export const refreshCasesSuccess = res => dispatch => {
  dispatch({ type: types.REFRESH_CASES_SUCCESS, res });
  dispatch(checkAllFormsValidity());
}
const getServerErrorNotification = (error) => {
  let errorMessage;
  if (error.response) {
    errorMessage = error.response.data.message;
  } else {
    errorMessage = 'Server might not be availible';
  }
  return {
    status: NOTIFICATION_STATUS.error,
    message: errorMessage,
  };
};


const getSuccessNotification = message => ({
  status: NOTIFICATION_STATUS.success,
  message,
});

export const getCases = (user, refresh) => async dispatch => {

  try {
    const res = await axios.post(`${API_URL_PATHS.apiUrl}/cases`,
      {
        user: user.email,
        userRole: user.role,
      },
      getTokenHeader()
    );

    if(user.role === userRoles.technician){
      res.data = res.data.filter(_case => _case.status.workFlowStatusDemo === caseStatus.workFlowStatusDemo.AWAITING_UPLOAD)
    }

    refresh ? dispatch(refreshCasesSuccess(res)) : dispatch(getCasesSuccess(res));
  } catch (err) {
    console.log(err);
  }
};

export const toggleForm = () => dispatch => {
  dispatch({ type: "toggle-form", payload: false });
  setTimeout(() => {
    dispatch({ type: "toggle-form", payload: true });
  }, 1);

};

export const createCase = () => async dispatch => {
  try {
    const res = await axios.get(`${API_URL_PATHS.apiUrl}/caseId`, getTokenHeader());
    dispatch({ type: types.CREATE_CASE, id: res.data });
    dispatch({ type: types.CASE_PART_SELECT, selectedPart: null });
    dispatch({ type: types.CASE_PART_SELECT, selectedPart: CASE_PART_ONE });
    dispatch({ type: types.CLEAR_TEMP_PATHOLOGIST_ASSIGNMENT });
  } catch (err) {
    console.log(err);
  }
};

export const createCasePreFilledDataByPatientIdentifier = (patientIdentifier) => async dispatch => {
  try {
    const res = await axios.get(`${API_URL_PATHS.cadessUrl}/lis/case/${patientIdentifier}`, CADESS_API_CONFIG);
    const formValues = res.data;
    formValues.hasChanged = false;
    dispatch(createCase()).then(() => dispatch(updateCaseClinicalTemp(formValues)));
  } catch (e) {
    const notification = {
      status: NOTIFICATION_STATUS.error,
      // todo write better message based on error 
      message: `Patient with identifier "${patientIdentifier}" was not found`,
    };
    dispatch(displayNotification(notification));
  }
};

export const caseSelect = (_case, user) => async dispatch => {
  try {
    const res = user.role === userRoles.pathologist
      ? await axios.get(`${API_URL_PATHS.apiUrl}/pathologistSpecimens/${_case.id}`, getTokenHeader())
      : await axios.get(`${API_URL_PATHS.apiUrl}/specimens/${_case.id}`, getTokenHeader());

    const specimens = res.data;
    const payload = { _case, specimens, userId: user.email, userRole: user.role, user };
    dispatch(getSpecimensSuccess(payload));
    dispatch({ type: types.CLEAR_SNAPSHOT_LIST });
    dispatch(checkAllFormsValidity());

  } catch (err) {
    console.log(err);
    const notification = {
      status: NOTIFICATION_STATUS.error,
      message: 'Failed to get case. Server might not be available',
    };
    dispatch(displayNotification(notification));
  }
};

export const refreshSeadragon = () => dispatch => {
  dispatch({ type: types.REFRESH_SEADRAGON, payload: false });
  setTimeout(() => {
    dispatch({ type: types.REFRESH_SEADRAGON, payload: true });
  }, 0);
};

export const forceFormRefresh = () => dispatch => {
  dispatch({ type: types.SHOW_FORM, payload: false });
  setTimeout(() => {
    dispatch({ type: types.SHOW_FORM, payload: true });
  }, 0);
};

const deleteCaseSuccess = (_case, cases) => ({
  type: types.DELETE_CASE_SUCCESS, payload: { _case, cases },
});

export const deleteCase = _case => async dispatch => {
  dispatch(deleteCaseSuccess(_case));
};

export const archiveCase = _case => async dispatch => {
  try {
    await axios.post(`${API_URL_PATHS.apiUrl}/archive`, { id: _case.id, status: _case.status }, getTokenHeader());
    dispatch(deleteCaseSuccess(_case));
  } catch (e) {
    console.log(e);
  }
};

export const unarchiveCase = _case => async dispatch => {
  try {
    await axios.post(`${API_URL_PATHS.apiUrl}/unarchive`, { id: _case.id, status: _case.status }, getTokenHeader());

    _case.status.archiveStatus = caseStatus.archiveStatus.ACTIVE;
    dispatch({ type: types.ACTIVATE_CASE_SUCCESS, payload: _case });
  } catch (e) {
    console.log(e);
  }
};


export const casePartSelect = selectedPart => ({ type: types.CASE_PART_SELECT, selectedPart });

const getSpecimensSuccess = payload => ({ type: types.GET_SPECIMENS_SUCCESS, payload: payload });

export const updateCase = (data, part) => async dispatch => {
  try {
    const res = await axios.post(`${API_URL_PATHS.apiUrl}/case`, data, getTokenHeader());

    dispatch({ type: types.NEW_CASE_SAVED });
    dispatch({ type: types.UPDATE_CASE_SUCCESS, payload: { cases: res.data.cases, _case: res.data._case } });
    part === CASE_LEVEL ? dispatch({ type: types.CONFIRM_CASE_LEVEL_PRISTINE }) :
      dispatch({ type: types.CONFIRM_CASE_GENERAL_PRISTINE });

    dispatch(displayNotification(getSuccessNotification('Case updated')));
  } catch (err) {
    dispatch(displayNotification(getServerErrorNotification(err)));
    console.log(err);
  }
};

export const setCaseStatus = (status, caseId) => async dispatch => {
  try {
    const res = await axios.post(`${API_URL_PATHS.apiUrl}/demo/case/${caseId}/status`, { status }, getTokenHeader());
    dispatch(refreshCasesSuccess(res));
    dispatch(displayNotification(getSuccessNotification(`Case Status Is Set To "${status}"`)));
  } catch (e) {
    console.log("ERROR", e);
  }
}
export const saveCaseLevelAnalysisClientOnly = (analysis, pathologist, caseId) => {
  // todo fix this, reducer of UPDATE_CASE is not expecting this payload...
  return { type: types.UPDATE_CASE, payload: { analysis, pathologist, caseId, hasUnsavedChanges: true } }
};

export const storeUnsavedAnalysis = (values, formId) => (
  { type: types.STORE_UNSAVED_ANALYSIS, payload: { values, formId } }
);

export const removeStoredUnsavedAnalysis = (formId) => (
  { type: types.REMOVE_STORED_UNSAVED_ANALYSIS, payload: { formId } }
);

export const checkAllFormsValidity = () => ({ type: types.CHECK_ALL_FORMS_VALIDITY })

export const saveCaseLevelAnalysis = (analysis, pathologist, caseId, formId) => async dispatch => {
  const isValid = validateAnalysisValues(analysis);
  const body = {
    caseId,
    analysis,
    pathologist,
    isValid,
  };
  try {
    const res = await axios.post(`${API_URL_PATHS.apiUrl}/case/analysis`, body, getTokenHeader());
    if (res.status === 200) {
      dispatch(displayNotification(getSuccessNotification('Analysis updated')));
      dispatch({
        type: types.UPDATE_CASE,
        payload: {
          analysis,
          pathologist,
          caseId,
          hasUnsavedChanges: false,
          isValid,
        },
      });
      dispatch(removeStoredUnsavedAnalysis(formId));
      dispatch(checkAllFormsValidity());
    }
  } catch (e) {
    dispatch(displayNotification(getServerErrorNotification(e)));
    console.log(e);
  }
};

export const updateCaseClinicalTemp = data => {
  return {
    type: types.SAVE_TEMP_CLINICAL_INFO,
    payload:
    {
      partOneClinicalInformation: data.caseClinicalInformation,
      partOneGeneralInformation: data.caseGeneralInformation,
      hasChanged: data.hasChanged,
    },
  }
};

export const getAllPathologists = () => async dispatch => {
  try {
    const response = await axios.get(`${API_URL_PATHS.apiUrl}/users/pathologist`, getTokenHeader());

    const allPathologists = response.data[`${userRoles.pathologist}`].concat(response.data[`${userRoles.val_pathologist}`]);

    dispatch({ type: types.GET_PATHOLOGISTS_SUCCESS, payload: allPathologists });
  } catch (e) {
    console.log(e);
  }
};

export const selectPathologist = pathologist => {
  return ({ type: types.SELECT_PATHOLOGIST, payload: pathologist })
};

export const updateTempCaseLevel = (caseData, hasChanged) => dispatch => {
  dispatch({ type: types.SAVE_TEMP_CASE_LEVEL, payload: { caseData, hasChanged } });
};

export const updatePortalValues = portalData => (
  { type: types.UPDATE_PORTAL_VALUES, payload: { portalData } }
);

export const flagUnsavedTabs = () => dispatch => {
  dispatch({ type: types.FLAG_UNSAVED_TABS });
};

export const displayWrapper = () => ({ type: types.DISPLAY_WRAPPER });

export const togglePortal = () => ({ type: types.TOGGLE_PORTAL });

export const flagGeneral = () => ({ type: types.FLAG_GENERAL });

export const flagCaseLevel = () => ({ type: types.FLAG_CASE_LEVEL });

export const flagSpecimen = () => ({ type: types.FLAG_SPECIMEN });



/** Temporarily stores an array of user ids referencing which pathologists
 *  should be assigned the selected case, before actually
 *  making an post req to the server */
export const addPathologistToTempAssignment = (pathologistId) => ({
  type: types.SAVE_TEMP_PATHOLOGISTS_TO_ASSIGN,
  payload: pathologistId,
});

export const removePathologistFromTempAssignment = (pathologistId) => ({
  type: types.REMOVE_TEMP_PATHOLOGISTS_TO_ASSIGN,
  payload: pathologistId,
});

export const addPathologistToTempUnassignment = (pathologistId) => ({
  type: types.SAVE_TEMP_PATHOLOGISTS_TO_UNASSIGN,
  payload: pathologistId,
});

export const removePathologistFromTempUnassignment = (pathologistId) => ({
  type: types.REMOVE_TEMP_PATHOLOGISTS_TO_UNASSIGN,
  payload: pathologistId,
});

export const updatePathologistsSuccess = (pathologists, caseId) => ({
  type: types.UPDATE_ASSIGNED_PATHOLOGISTS_SUCCESS,
  payload: { pathologists, caseId },
});


export const savePathologistAssignmentsToCase = (
  pathologistsToAssign,
  pathologistsToUnassign,
  caseId,
) => async dispatch => {
  const body = {
    pathologistsToAssign,
    pathologistsToUnassign,
  };

  try {
    const response = await axios.put(`${API_URL_PATHS.apiUrl}/cases/${caseId}/pathologists`, body, getTokenHeader());
    if (response.status === 200) {
      dispatch(updatePathologistsSuccess(response.data, caseId));
      dispatch({ type: types.CLEAR_TEMP_PATHOLOGIST_ASSIGNMENT });
    }
  } catch (err) {
    dispatch(displayNotification(getServerErrorNotification(err)));
    console.error(err);
  }
};

